var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-dialog modal-lg" }, [
    _c("div", [
      _c("div", { staticClass: "modal-content" }, [
        _c("div", { staticClass: "modal-body" }, [
          _c(
            "a",
            {
              staticClass: "close",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.closeModal($event)
                }
              }
            },
            [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-7" },
              [
                _c("h3", { staticClass: "modal-title" }, [
                  _vm._v(
                    _vm._s(_vm.selectedFellow.FirstName) +
                      " " +
                      _vm._s(_vm.selectedFellow.LastName)
                  )
                ]),
                _vm._v(" "),
                _c("h6", { attrs: { id: "fellow-college" } }, [
                  _vm._v(_vm._s(_vm.selectedFellow.Account.Name))
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _vm.selectedFellow.Applications__r &&
                _vm.selectedFellow.Applications__r.records.length
                  ? [
                      _vm.selectedFellow.Applications__r.records[0].RecordType
                        .Name == "TJ Application" ||
                      _vm.selectedFellow.Applications__r.records[0].RecordType
                        .Name == "TJ Application-Offer"
                        ? [
                            _vm._m(0),
                            _vm._v(" "),
                            _c("h2", { attrs: { id: "fellow-project" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.selectedFellow.Applications__r.records[0]
                                    .Proposed_Project_Title__c
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("h5", [
                              _c(
                                "small",
                                { attrs: { id: "fellow-countries" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.selectedFellow.Applications__r
                                        .records[0]
                                        .Proposed_Project_Countries__c
                                    )
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { attrs: { id: "fellow-description" } }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.selectedFellow.Applications__r
                                      .records[0].Summary_of_Proposed_Project__c
                                  ) +
                                  "\n                "
                              )
                            ])
                          ]
                        : [
                            _c("div", { attrs: { id: "fellow-description" } }, [
                              _vm._m(1),
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.selectedFellow.Applications__r
                                      .records[0].Professional_Aspiration__c
                                  ) +
                                  "\n                "
                              )
                            ])
                          ]
                    ]
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-5 hidden-sm hidden-xs" },
              [
                _vm.fellowPhoto
                  ? _c("div", {
                      staticClass: "img-circle img-tj",
                      domProps: { innerHTML: _vm._s(_vm.fellowPhoto) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.continents &&
                _vm.selectedFellow.Applications__r &&
                _vm.selectedFellow.Applications__r.records.length &&
                _vm.selectedFellow.Applications__r.records[0]
                  .Proposed_Project_Countries__c
                  ? [
                      _c("tj-modal-map", {
                        attrs: {
                          continents: _vm.continents,
                          countries:
                            _vm.selectedFellow.Applications__r.records[0]
                              .Proposed_Project_Countries__c
                        }
                      })
                    ]
                  : _c("img", {
                      attrs: {
                        src: "/images/profile-icon.png",
                        width: "202",
                        height: "202",
                        alt: "Profile icon"
                      }
                    })
              ],
              2
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", [_c("small", [_vm._v("Project")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", [_c("small", [_vm._v("Bio")])])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07732ecb", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07732ecb","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/tj-modal.vue
// module id = 395
// module chunks = 0